var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _g5, _path7, _g6, _path8, _path9, _g7, _path10, _g8, _path11, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 5.55566V19.192H20.6258L24.9996 11.6163H36.1107V5.55566H15.6523Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 5.55566V19.192H20.6258L24.9996 11.6163H36.1107V5.55566H15.6523Z",
    fill: "url(#paint0_linear_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7458 19.1479L15.7168 10.5229L15.6436 10.6492L20.636 19.2098L20.7458 19.1479Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 27.7776H24.4657L29.3748 22.8686V19.1918H20.626L13.8887 7.63623V27.7776Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 27.7776H24.4657L29.3748 22.8686V19.1918H20.626L13.8887 7.63623V27.7776Z",
    fill: "url(#paint1_linear_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2723 19.3599L29.1675 19.2993L24.3203 27.7779H24.4655L29.2761 19.3637L29.2723 19.3599Z",
    fill: "#263238",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11303_64545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 7,
    width: 17,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 27.7776H24.4657L29.3748 22.8686V19.1918H20.626L13.8887 7.63623V27.7776Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.6162L29.3749 19.192L24.4658 27.7778H36.111V11.6162H24.9999Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.6162L29.3749 19.192L24.4658 27.7778H36.111V11.6162H24.9999Z",
    fill: "url(#paint2_linear_11303_64545)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.6162L29.3749 19.192L24.4658 27.7778H36.111V11.6162H24.9999Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.6162L29.3749 19.192L24.4658 27.7778H36.111V11.6162H24.9999Z",
    fill: "url(#paint3_linear_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11303_64545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 11,
    width: 13,
    height: 17
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.6162L29.3749 19.192L24.4658 27.7778H36.111V11.6162H24.9999Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 5.55566V19.192H20.6258L24.9996 11.6163H36.1107V5.55566H15.6523Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 5.55566V19.192H20.6258L24.9996 11.6163H36.1107V5.55566H15.6523Z",
    fill: "url(#paint4_linear_11303_64545)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6162V14.2614L34.899 11.6162H25Z",
    fill: "url(#paint5_radial_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11303_64545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 5,
    width: 22,
    height: 15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 5.55566V10.6491L20.6258 19.192L24.9996 11.6163H36.1107V5.55566H15.6523Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 27.7776H24.4657L29.3748 22.8686V19.1918H20.626L13.8887 7.63623V27.7776Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 27.7776H24.4657L29.3748 22.8686V19.1918H20.626L13.8887 7.63623V27.7776Z",
    fill: "url(#paint6_linear_11303_64545)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 10.6631L22.8809 17.8904L20.6258 19.1921L15.6523 10.6631Z",
    fill: "url(#paint7_radial_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4736 27.7639L27.1201 17.8901L29.3751 19.1919L24.4736 27.7639Z",
    fill: "url(#paint8_radial_11303_64545)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 21.7172C27.789 21.7172 30.0502 19.456 30.0502 16.6667C30.0502 13.8774 27.789 11.6162 24.9997 11.6162C22.2104 11.6162 19.9492 13.8774 19.9492 16.6667C19.9492 19.456 22.2104 21.7172 24.9997 21.7172Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 20.7073C27.2308 20.7073 29.0398 18.8983 29.0398 16.6669C29.0398 14.4354 27.2308 12.6265 24.9994 12.6265C22.7679 12.6265 20.959 14.4354 20.959 16.6669C20.959 18.8983 22.7679 20.7073 24.9994 20.7073Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 11.4897C22.2106 11.4897 19.9492 13.7511 19.9492 16.5403V16.6665C19.9492 13.8774 22.2106 11.616 24.9997 11.616H36.1108V11.4897H24.9997Z",
    fill: "#3E2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3685 19.1918C28.4947 20.6994 26.8672 21.717 24.9998 21.717C23.1311 21.717 21.5036 20.6994 20.6298 19.1918H20.6248L13.8887 7.63623V7.76249L20.626 19.318H20.6311C21.5048 20.8256 23.1324 21.8433 25.001 21.8433C26.8685 21.8433 28.496 20.8269 29.3697 19.318H29.376V19.1918H29.3685Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.1256 11.6162C25.1042 11.6162 25.084 11.6187 25.0625 11.62C27.8226 11.6541 30.0499 13.899 30.0499 16.6667C30.0499 19.4344 27.8226 21.6793 25.0625 21.7134C25.084 21.7134 25.1042 21.7172 25.1256 21.7172C27.9148 21.7172 30.1761 19.4559 30.1761 16.6667C30.1761 13.8776 27.9148 11.6162 25.1256 11.6162Z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4191 19.3597C29.8484 18.6173 30.0971 17.7587 30.0971 16.8395C30.0971 16.3067 30.0138 15.794 29.861 15.313C29.981 15.7448 30.0504 16.1981 30.0504 16.6678C30.0504 17.587 29.8017 18.4456 29.3724 19.188L29.3749 19.193L24.4658 27.7789H24.6123L29.4216 19.3648L29.4191 19.3597Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11303_64545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 24,
    height: 23
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11303_64545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 5.68193C31.1147 5.68193 36.0755 10.6226 36.1096 16.7299C36.1096 16.7084 36.1109 16.6882 36.1109 16.6668C36.1109 10.5304 31.1361 5.55566 24.9998 5.55566C18.8634 5.55566 13.8887 10.5304 13.8887 16.6668C13.8887 16.6882 13.8899 16.7084 13.8899 16.7299C13.924 10.6226 18.8849 5.68193 24.9998 5.68193Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.6515C31.1147 27.6515 36.0755 22.7108 36.1096 16.6035C36.1096 16.625 36.1109 16.6452 36.1109 16.6666C36.1109 22.803 31.1361 27.7778 24.9998 27.7778C18.8634 27.7778 13.8887 22.803 13.8887 16.6666C13.8887 16.6452 13.8899 16.625 13.8899 16.6035C13.924 22.7108 18.8849 27.6515 24.9998 27.6515Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 27.7779C31.1363 27.7779 36.1109 22.8033 36.1109 16.6668C36.1109 10.5303 31.1363 5.55566 24.9998 5.55566C18.8633 5.55566 13.8887 10.5303 13.8887 16.6668C13.8887 22.8033 18.8633 27.7779 24.9998 27.7779Z",
    fill: "url(#paint9_radial_11303_64545)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11303_64545",
    x1: 16.5825,
    y1: 14.0179,
    x2: 23.2113,
    y2: 10.1458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11303_64545",
    x1: 26.8773,
    y1: 25.3155,
    x2: 19.5122,
    y2: 21.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11303_64545",
    x1: 28.2651,
    y1: 10.8339,
    x2: 30.1199,
    y2: 18.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11303_64545",
    x1: 28.2651,
    y1: 10.8339,
    x2: 30.1199,
    y2: 18.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11303_64545",
    x1: 16.5825,
    y1: 14.0179,
    x2: 23.2113,
    y2: 10.1458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_11303_64545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5177 11.6096) scale(10.6159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11303_64545",
    x1: 26.8773,
    y1: 25.3155,
    x2: 19.5122,
    y2: 21.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_11303_64545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.641 10.6719) scale(9.85404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_11303_64545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9799 16.6841) scale(11.0947 11.0947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_11303_64545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2076 8.58773) scale(22.3169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.37684722f1533405c95f57198dbfb781.svg";
export { ForwardRef as ReactComponent };